import styled from 'styles/styled';
import copyIconImg from '../../assets/Icon/Copyicon.svg';
import metamaskIcon from '../../assets/icons/metamask.svg';

export const Wrap = styled.section<{ $isMobile?: boolean }>`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.darkMedium};
  border-radius: 10px;
  padding: ${({ $isMobile }) => ($isMobile ? '16px' : '24px')};
  display: flex;
  flex-direction: column;
  gap: ${({ $isMobile }) => ($isMobile ? '12px' : '16px')};
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.white};
  margin: 0;
`;

export const SubTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  color: ${({ theme }) => theme.palette.white};
  margin: 0;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.grayLight};
  margin: 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const BoxQR = styled.div<{ $fullWidth?: boolean }>`
  border: 1px solid ${({ theme }) => theme.palette.grayMedium3};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.dark};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  max-width: ${({ $fullWidth }) => ($fullWidth ? '360px' : 'none')};
  margin: ${({ $fullWidth }) => ($fullWidth ? '0 auto' : '0')};
`;

export const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.palette.primary};
  background: rgba(82, 211, 129, 0.12);
  color: ${({ theme }) => theme.palette.primary};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  transition: ${({ theme }) => theme.ui.transition('opacity')};

  &:hover {
    opacity: 0.85;
  }
`;

export const IconCopy = styled.span`
  width: 16px;
  height: 16px;
  display: inline-flex;
  background-image: url(${copyIconImg});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const DesktopColumns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 32px;
  align-items: flex-start;
`;

export const DetailsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const QRPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;
`;

export const MobileLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ActionsRow = styled(Row)<{ $fullWidth?: boolean }>`
  justify-content: ${({ $fullWidth }) => ($fullWidth ? 'stretch' : 'flex-start')};

  ${Btn} {
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  }
`;

// QR + MetaMask container (Figma layout)
export const QRWithMetaMask = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

// MetaMask button (Figma: Group 48343)
export const MetaMaskBtn = styled.button`
  width: 76px;
  height: 76px;
  background: #292B2E;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary};
    outline-offset: 2px;
  }
`;

export const MetaMaskIcon = styled.span`
  width: 46px;
  height: 44px;
  display: inline-flex;
  background-image: url(${metamaskIcon});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;
